import React from 'react';
import AccountMasterReport from '../AccountMasterReport';

export default function ReportAccountMaster({ sessionObject }) {
  return (
    <div className="page-challan">
        <AccountMasterReport sessionObject={sessionObject}/>
    </div>
  );
}
